import React from 'react';
import { FadeIn } from './FadeIn';
import { TrustBadges } from './TrustBadges';
import { ChevronRightIcon, CheckCircle2Icon } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-16 sm:py-24 px-4 bg-padel-surface relative" data-id="element-135">
      <div className="max-w-xl mx-auto" data-id="element-136">
        {/* Single Offer */}
        <FadeIn delay={0.1} data-id="element-137">
          <div className="bg-gradient-to-b from-padel-surfaceHover to-padel-dark border-2 border-padel-lime p-8 sm:p-10 rounded-3xl flex flex-col relative shadow-[0_0_40px_rgba(197,255,61,0.15)]" data-id="element-138">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-padel-lime text-padel-dark font-bold px-4 py-1 rounded-full text-sm uppercase tracking-wider" data-id="element-139">
              Oferta de lanzamiento
            </div>

            <div className="text-center mb-6 mt-2" data-id="element-140">
              <span className="text-3xl mb-3 block" data-id="element-141">📘</span>
              <h3 className="text-2xl sm:text-3xl font-display font-bold text-white mb-2" data-id="element-142">
                MÉTODO PRO-PÁDEL 360
              </h3>
              <p className="text-gray-400" data-id="element-143">
                El sistema completo para transformar tus clases.
              </p>
            </div>

            <ul className="space-y-3 mb-8 max-w-sm mx-auto w-full" data-id="element-144">
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-145">
                <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-146" />
                <span data-id="element-147">6 Tomos del Método</span>
              </li>
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-148">
                <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-149" />
                <span data-id="element-150">6 Bonos Exclusivos</span>
              </li>
              <li className="flex items-center gap-3 text-white font-medium" data-id="element-151">
                <CheckCircle2Icon className="w-5 h-5 text-padel-lime shrink-0" data-id="element-152" />
                <span data-id="element-153">420+ páginas listas para usar</span>
              </li>
            </ul>

            <div className="text-center mb-8" data-id="element-154">
              <div className="text-gray-500 line-through text-lg mb-1" data-id="element-155">
                $89.000
              </div>
              <div className="text-5xl sm:text-6xl font-display font-black text-padel-lime drop-shadow-[0_0_15px_rgba(197,255,61,0.3)]" data-id="element-156">
                $17.990{' '}
                <span className="text-2xl text-gray-400 font-sans font-normal" data-id="element-157">
                  ARS
                </span>
              </div>
            </div>

            <a href="https://stock-digital-shop.impultienda.ar/checkout" target="_blank" rel="noopener noreferrer" className="w-full bg-padel-lime hover:bg-padel-limeHover text-padel-dark font-display font-black text-xl px-6 py-5 rounded-xl flex items-center justify-center gap-2 transition-all transform hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_20px_rgba(197,255,61,0.2)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-padel-lime focus-visible:ring-offset-2 focus-visible:ring-offset-padel-dark" data-id="element-158">
              QUIERO MI PACK AHORA
              <ChevronRightIcon className="w-6 h-6" strokeWidth={3} data-id="element-159" />
            </a>

            <div className="mt-8" data-id="element-160">
              <TrustBadges data-id="element-161" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}